import React, { createContext, useContext, useState } from "react";

interface ModalContextType {
    showModalA: boolean;
    showModalB: boolean;
    showModalC: boolean;
    modalData: any[] | null;
    openModalA: (data?: any) => void;
    openModalB: (data?: any) => void;
    openModalC: () => void;
    closeModals: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [showModalA, setShowModalA] = useState(false);
    const [showModalB, setShowModalB] = useState(false);
    const [showModalC, setShowModalC] = useState(false);
    const [modalData, setModalData] = useState<any | null>(null);

    const openModalA = (data?: any[]) => {
        setShowModalA(true);
        setModalData(data || null);
    };

    const openModalB = (data?: any[]) => {
        setShowModalA(false);
        setShowModalB(true);
        setModalData(data || null);
    };

    const openModalC = () => {
        setShowModalB(false);
        setShowModalC(true);
        setModalData(null);
    };

    const closeModals = () => {
        setShowModalA(false);
        setShowModalB(false);
        setShowModalC(false);
        setModalData(null);
    };

    return (
        <ModalContext.Provider
            value={{
                showModalA,
                showModalB,
                showModalC,
                modalData,
                openModalA,
                openModalB,
                openModalC,
                closeModals,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};